import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { queueCreationType, queueListingType } from '../types/queueCreation.types'
const initialState: queueCreationType = {
  children: [],
  selectedQueue: '',
}

const queueCreationSlice = createSlice({
  name: 'queueCreation',
  initialState: initialState,
  reducers: {
    setSelectedQueueReducer:(
      state: queueCreationType,
      action: PayloadAction<string>
    ) =>
    {
      state.selectedQueue = action.payload
    },
    setQueueCreation: (
      state: queueCreationType,
      action: PayloadAction<{queueData : queueListingType, type : 'post' | 'update' | 'delete'}>
    ) => {
      if (action?.payload?.type === 'post') {
        state?.children?.push(action?.payload?.queueData)
      } 
      else if (action?.payload?.type === 'update') {
        if (action?.payload?.queueData?.id) {
          state.children = state.children.map((item: queueListingType) => {
            return item?.id === action.payload.queueData.id ? {...action.payload.queueData } : item
          })
        }
      } 
      else if (action?.payload?.type === 'delete') {
        if (action?.payload?.queueData?.id) {
          state.children = state.children.filter((item: queueListingType) => {
            return item?.id !== action.payload.queueData.id
          })
        }
      }
    },
    mapQueueCreationNav: (
      state: queueCreationType,
      action: PayloadAction<queueListingType[]>
    ) => {
      const uniqueByName = Array.from(
        new Map(action.payload.map(item => [item.name, item])).values()
      );
      state.children = uniqueByName;
    },
    deleteQueue : (state : queueCreationType, action: PayloadAction<number>) =>
    {
      state.children = state.children.filter((item: queueListingType) => {
        return item?.id !== action.payload
      })
    },
    toggleQueueReducer : (state : queueCreationType, action: PayloadAction<{queueData: queueListingType, enabled : boolean, id : number}>) =>
    {
      if(action?.payload?.enabled === true)
      {
        state.children = state.children.filter((item: queueListingType) => {
          return item?.id !== action.payload?.id
        })
      }
      else
      {
        state?.children?.push(action?.payload?.queueData)
      }
    }
  },
})

export const { setSelectedQueueReducer, setQueueCreation, mapQueueCreationNav, deleteQueue, toggleQueueReducer } =
  queueCreationSlice.actions
export default queueCreationSlice.reducer
